import { API_BASE_URL } from "@/config";
import { BaseService } from "@/services/base-service";
import { CsrfService } from "@/services/csrf/csrf-service";
import type { LcrOrder } from "@/services/orders/lcr-order.types";
import {
  toReplacementOrderResult,
  toReplacementOrderSubmitError,
  toSubmitReplacementOrderBody,
} from "./replacement-order.mapper";
import type { ReplacementOrderRequest, ReplacementOrderResult } from "./replacement-order.types";
import type { ReplacementOrderService } from "./replacement-order-service";

const LCR_ORDERS_PATH = "/v1/orders/lcr";

export class HttpReplacementOrderService extends BaseService implements ReplacementOrderService {
  private readonly csrfService: CsrfService;

  public constructor(csrfService: CsrfService = new CsrfService()) {
    super(API_BASE_URL);
    this.csrfService = csrfService;
  }

  public async submit(request: ReplacementOrderRequest): Promise<ReplacementOrderResult> {
    const csrfToken = await this.csrfService.getToken();
    const response = await this.fetch(LCR_ORDERS_PATH, {
      method: "POST",
      headers: { "Content-Type": "application/json", "x-csrf-token": csrfToken },
      body: JSON.stringify(toSubmitReplacementOrderBody(request)),
    });
    if (!response.ok) {
      const errorBody = await response.json().catch(() => undefined);
      throw toReplacementOrderSubmitError(response.status, errorBody);
    }
    return toReplacementOrderResult((await response.json()) as LcrOrder);
  }
}
